import { render } from "./tubeComponentFormRow.vue?vue&type=template&id=97f0888c"
import script from "./tubeComponentFormRow.vue?vue&type=script&lang=js"
export * from "./tubeComponentFormRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__